import { useEffect, useState } from 'preact/hooks';
import { get } from '../../api';
import type { ContentDraft } from '../../types';
import { LcarsPanel } from '../layout/LcarsPanel';
import { LoadingSpinner } from '../shared/LoadingSpinner';

const CHANNEL_COLORS: Record<string, string> = {
  Blog: 'var(--blue)',
  Newsletter: 'var(--lilac)',
  Social: 'var(--canary)',
  Video: 'var(--orange)',
};

export function ChannelsPanel() {
  const [channels, setChannels] = useState<Record<string, number> | null>(null);

  useEffect(() => {
    get<{ drafts: ContentDraft[] }>('/api/drafts?status=')
      .then((data) => {
        const counts: Record<string, number> = {};
        for (const d of data.drafts) {
          const ch = d.channel || 'Other';
          counts[ch] = (counts[ch] || 0) + 1;
        }
        setChannels(counts);
      })
      .catch(console.error);
  }, []);

  if (!channels) {
    return (
      <LcarsPanel color="var(--orpeel)" title="Channels">
        <LoadingSpinner />
      </LcarsPanel>
    );
  }

  const max = Math.max(1, ...Object.values(channels));
  const entries = Object.entries(channels).sort((a, b) => b[1] - a[1]);

  return (
    <LcarsPanel color="var(--orpeel)" title="Channels">
      <div class="channel-list">
        {entries.map(([name, count]) => (
          <div class="ch-row" key={name}>
            <div class="ch-dot" style={{ background: CHANNEL_COLORS[name] || 'var(--peach)' }}></div>
            <div class="ch-name">{name}</div>
            <div class="ch-track">
              <div class="ch-bar" style={{ width: `${(count / max) * 100}%`, background: CHANNEL_COLORS[name] || 'var(--peach)' }}></div>
            </div>
            <div class="ch-count">{count}</div>
          </div>
        ))}
      </div>
    </LcarsPanel>
  );
}
